"use client";

interface AboutAreaSectionProps {
  badge: string;
  imageSrc: string;
  imageAlt: string;
  heading: string;
  lead: string;
  bullets: string[];
  closing: string;
}

export default function AboutAreaSection({
  badge,
  imageSrc,
  imageAlt,
  heading,
  lead,
  bullets,
  closing,
}: AboutAreaSectionProps) {
  return (
    <section className="bg-white py-[70px]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-[50px] items-center">
          {/* LEFT: Image */}
          <div className="order-1 md:order-1">
            <img
              src={imageSrc}
              alt={imageAlt}
              width={520}
              height={380}
              loading="lazy"
              className="w-full max-w-[520px] rounded-xl shadow-md"
            />
          </div>

          {/* RIGHT: Text */}
          <div className="order-2 md:order-2">
            <span className="inline-block bg-[#047857] text-white uppercase text-[11px] tracking-[1px] font-semibold px-3 py-[5px] rounded-[14px]">
              {badge}
            </span>

            <h2 className="text-[#064e3b] text-[28px] leading-tight font-bold mt-[14px]">
              {heading}
            </h2>

            <p className="text-[#374151] text-[15px] leading-[1.7] mt-[14px]">
              {lead}
            </p>

            <ul className="mt-4 space-y-3">
              {bullets.map((item) => (
                <li key={item} className="flex items-start gap-3 text-[#374151] text-[14px] leading-[1.6]">
                  <i className="ri-check-line text-[#047857] text-[14px] mt-0.5 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <p className="text-gray-500 text-[13px] italic mt-[14px]">
              {closing}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}